import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  /* padding-bottom: 10px;
  padding-top: 10px; */
  padding: 10px 10px 10px 10px;
  h1 {
    text-align: center;
  }
  p {
    text-align: center;
  }

  strong {
    text-align: center;
  }
`;
